<form>
    <div class="condition-container">
        <h4 class="red-title">{{ groupId }} - {{ conditionType.label }}</h4>

        <div class="inputs-container">
            <!-- Category -->
            <div class="tv-container-select-white-rect-extensible">
                <mat-form-field>
                    <mat-label>Catégorie de la négociation</mat-label>
                    <mat-select panelClass="tv-custom-always-visible-scroll-bar" [formControl]="categoryTypeFormControl">
                        <mat-option *ngFor="let category of categoryTypeList" class="tv-ns-select-option" [value]="category">
                            {{ category.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <!-- Search Item -->
            <div class="tv-rect-input-extensible">
                <mat-form-field>
                    <mat-label>Rechercher</mat-label>
                    <input
                        class="tv-ns-select-option"
                        type="text"
                        aria-label="Number"
                        matInput
                        [formControl]="searchFormControl"
                        [matAutocomplete]="auto" />
                    <mat-autocomplete autoActiveFirstOption class="tv-custom-always-visible-scroll-bar" #auto="matAutocomplete" [displayWith]="displayItem">
                        <mat-option *ngFor="let item of filteredItemList | async" class="tv-ns-select-option" [value]="item">
                            {{ item.name }} ({{ item.id }})
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>

            <!-- List Button-->
            <button [disabled]="isFilteredItemListFill()" (click)="listAllOptions()" class="tv-round-icon-button-icon-medium-light-blue">
                <mat-icon>list</mat-icon>
            </button>

            <!-- Delete condition button -->
            <button class="tv-round-icon-button-icon-medium-light-blue" (click)="removeCondition()">
                <mat-icon class="material-icons-outlined">delete</mat-icon>
            </button>
        </div>

        <div>
            <mat-chip-set class="tv-chip-dark-square">
                <mat-chip *ngFor="let chip of chosenItemList" (removed)="removeItem(chip)">
                    {{ getCategoryTypeToDisplay(chip.itemType) }} - {{ chip.item.name }}
                    <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip>
            </mat-chip-set>
        </div>
    </div>
</form>
